/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Contact_TitleInputs */

const en_privacy_contact_title = /** @type {(inputs: Privacy_Contact_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6. Contact`)
};

const de_privacy_contact_title = /** @type {(inputs: Privacy_Contact_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6. Kontakt`)
};

const fr_privacy_contact_title = /** @type {(inputs: Privacy_Contact_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6. Contact`)
};

const es_privacy_contact_title = /** @type {(inputs: Privacy_Contact_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6. Contacto`)
};

const it_privacy_contact_title = /** @type {(inputs: Privacy_Contact_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6. Contatti`)
};

const nl_privacy_contact_title = /** @type {(inputs: Privacy_Contact_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6. Contact`)
};

const pl_privacy_contact_title = /** @type {(inputs: Privacy_Contact_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6. Kontakt`)
};

const fi_privacy_contact_title = /** @type {(inputs: Privacy_Contact_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6. Yhteystiedot`)
};

const da_privacy_contact_title = /** @type {(inputs: Privacy_Contact_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6. Kontakt`)
};

const sv_privacy_contact_title = /** @type {(inputs: Privacy_Contact_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6. Kontakt`)
};

/**
* | output |
* | --- |
* | "6. Contact" |
*
* @param {Privacy_Contact_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const privacy_contact_title = /** @type {((inputs?: Privacy_Contact_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Contact_TitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_privacy_contact_title(inputs)
	if (locale === "fr") return fr_privacy_contact_title(inputs)
	if (locale === "es") return es_privacy_contact_title(inputs)
	if (locale === "it") return it_privacy_contact_title(inputs)
	if (locale === "nl") return nl_privacy_contact_title(inputs)
	if (locale === "pl") return pl_privacy_contact_title(inputs)
	if (locale === "fi") return fi_privacy_contact_title(inputs)
	if (locale === "da") return da_privacy_contact_title(inputs)
	if (locale === "sv") return sv_privacy_contact_title(inputs)
	return en_privacy_contact_title(inputs)
});